import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7687d08a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "nav primary__dark__color__bg"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "material-icons home-icon" }, " contacts ")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "nav-text" }, "QR ID", -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "material-icons home-icon" }, " airline_seat_individual_suite ")
], -1))
const _hoisted_6 = { class: "nav-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.type === 'sm')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass(["nav-item", { active: _ctx.route.name == 'QRRoute' }]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goTo('QRIdentification')))
        }, _hoisted_4, 2),
        _createElementVNode("div", {
          class: _normalizeClass(["nav-item", { active: _ctx.route.name == 'MyBookings' }]),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goTo('MyBookings')))
        }, [
          _hoisted_5,
          _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("bottomNavigation.bookings")), 1)
        ], 2)
      ]))
    : _createCommentVNode("", true)
}